// extracted by mini-css-extract-plugin
module.exports = {"subscription":"styles_subscription__1xoLB","inputAreaMobile":"styles_inputAreaMobile__35XLk"};